module.exports = require("slugify");